import RobotThink from "../assets/pictures/robot_think.gif";
import Button from "@mui/material/Button";

export default function QuizText(props) {
  return (
    <>
      <div className="quiz-text">Čo vydalo ten zvuk?</div>
      <img
        src={RobotThink}
        className="robot"
        id="robot-think"
        alt="Animation error"
      ></img>
      <Button
        className="outlined-button outlined-button-white"
        variant="outlined"
        onClick={() => {
          props.playSound();
        }}
      >
        Prehrať zvuk znovu
      </Button>
    </>
  );
}
